<template>
    <div class="research-question-container">
        <mc-form
            v-if="chooseQuestionList.length"
            ref="chooseQuestionRef"
            :model="{chooseQuestionList}"
            :readonly="readonly"
        >
            <mc-announcement
                title="单选题"
                type="info"
                class="mar-b-6"
            />
            <mc-card
                v-for="(item,index) in chooseQuestionList"
                :key="item.questionNumber"
                class="mar-b-6"
            >
                <mc-form-item
                    :rules="validateChooseQuestion"
                    :prop="`chooseQuestionList.${index}.assayQuestionAnswer`"
                >
                    <div class="sub-title">
                        问题{{ item.questionNumber + 1 }}:{{ item.question }}
                    </div>
                    <mc-choice
                        v-model="item.assayQuestionAnswer"
                        type="radio"
                        :showCheckAll="false"
                        :source="item.source"
                        :readonly="readonly"
                    />
                </mc-form-item>
            </mc-card>
        </mc-form>
        <mc-form
            v-if="questionAnswerList.length"
            ref="questionAnswerRef"
            :model="{questionAnswerList}"
            :readonly="readonly"
        >
            <mc-announcement
                title="问答题"
                type="info"
                class="mar-b-6"
            />
            <mc-card
                v-for="(item,index) in questionAnswerList"
                :key="item.questionNumber"
                class="mar-b-6"
            >
                <mc-form-item
                    :rules="validateQuestionAnswer(item.answerContentLengthLimit)"
                    :prop="`questionAnswerList.${index}.assayQuestionAnswer`"
                >
                    <div class="sub-title">
                        问题{{ item.questionNumber + 1 }}:{{ item.question }}
                    </div>
                    <div class="tips">
                        提示:{{ item.hintContent }}
                    </div>
                    <mc-input
                        v-model="item.assayQuestionAnswer"
                        type="textarea"
                        :readonly="readonly"
                    />
                </mc-form-item>
            </mc-card>
        </mc-form>
    </div>
</template>

<script>
import { getCurrentInstance, ref, watch } from '@vue/composition-api';
import Rules from '@lsfe/rules';
import { deepClone } from '@lsfe/tools';

const validateChooseQuestion = [
    Rules.isRequired('请选择'),
];
const validateQuestionAnswer = (max) => [
    Rules.isRequired('请选择输入'),
    Rules.lenRange({ min: 0, max }, `输入内容字数需要>=0且<=${max}`),
];
export default {
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const { proxy: { $message } } = getCurrentInstance();

        const chooseQuestionRef = ref(null);
        const questionAnswerRef = ref(null);
        const chooseQuestionList = ref([]);
        const questionAnswerList = ref([]);

        const handleChooseQuestionSource = (list) => list.map((item) => ({
            label: item.choiceContent,
            value: item.choiceNumber,
        }));


        const getData = () => {
            const deepCloneChooseQuestionList = deepClone(chooseQuestionList.value);
            const deepCloneAssayQuestionAnswerDTOList = deepClone(questionAnswerList.value);
            const mcQuetsionAnswerDTOList = deepCloneChooseQuestionList.map((item) => {
                const { questionNumber, assayQuestionAnswer } = item;
                const choiceNumberList = [assayQuestionAnswer];
                return {
                    questionNumber,
                    choiceNumberList,
                };
            });
            const assayQuestionAnswerDTOList = deepCloneAssayQuestionAnswerDTOList.map((item) => {
                const { assayQuestionAnswer, questionNumber } = item;
                return {
                    assayQuestionAnswer,
                    questionNumber,
                };
            });
            return {
                mcQuetsionAnswerDTOList,
                assayQuestionAnswerDTOList,
            };
        };

        const validate = async () => {
            const validateList = [];
            if (chooseQuestionRef.value) {
                validateList.push(chooseQuestionRef.value.validate());
            }
            if (questionAnswerRef.value) {
                validateList.push(questionAnswerRef.value.validate());
            }
            try {
                await Promise.all(validateList);
                return true;
            } catch (err) {
                $message.error('请按照页面提示修改信息');
                return false;
            }
        };

        const handleChooseQuestionAnswer = (nv, index) => nv.mcQuetsionAnswerDTOList[index].choiceNumberList[0];
        const handleChooseQuestionList = (nv) => {
            chooseQuestionList.value = (nv.mcQuestionDTO || []).map((item) => ({
                ...item,
                assayQuestionAnswer: props.readonly ? handleChooseQuestionAnswer(nv, item.questionNumber) : '',
                source: handleChooseQuestionSource(item.choiceItemDTOList),
            }));
        };
        const handleQuestionAnswer = (nv, index) => nv.assayQuestionAnswerDTOList[index].assayQuestionAnswer;
        const handleQuestionAnswerList = (nv) => {
            questionAnswerList.value = (nv.assayQuestionDTO || []).map((item) => ({
                ...item,
                assayQuestionAnswer: props.readonly ? handleQuestionAnswer(nv, item.questionNumber) : '',
            }));
        };

        watch(() => props.data, (nv = {}) => {
            if (Object.keys(nv).length) {
                handleChooseQuestionList(nv);
                handleQuestionAnswerList(nv);
            }
        }, { immediate: true, deep: true });


        return {
            chooseQuestionRef,
            questionAnswerRef,
            validateChooseQuestion,
            validateQuestionAnswer,

            chooseQuestionList,
            questionAnswerList,

            getData,
            validate,
        };
    },
};
</script>

<style scoped lang="scss">
.research-question-container{
    .sub-title{
        font-weight: bold;
    }

    .tips{
        padding-left: 10px;
        color:#00b85c;
        font-size: 12px;
    }

    .mar-b-6{
        margin-bottom: 6px;
    }
}
</style>
